import React, { Component } from 'react';
import {
  EditorState,
  convertToRaw
} from 'draft-js';
import { FontIcon} from 'react-md';
import draftToHtml from 'draftjs-to-html';
import {stateToHTML} from 'draft-js-export-html';
import createVideoPlugin from 'draft-js-video-plugin';
import math from 'mathjs';

const videoPlugin = createVideoPlugin();

const styleMap = {
  'ALIGN_CENTER': {
    textAlign: 'center',
  },
};


let customBlockStyleFn  = function(contentBlock) {
  const type = contentBlock.getType();

  if (type === 'unstyled') {

      const data  = contentBlock.getData();
      if( data.includes('ALIGN_CENTER'))
        return 'centerAlignBlock';
      if(data.includes('ALIGN_RIGHT'))
        return 'rightAlignBlock';
      if(data.includes('ALIGN_LEFT'))
        return 'leftAlignBlock';

  }
}

let options = {
  blockRenderers: {
    unstyled: (block) => {
      let data = block.getData();

      let blockText = block.getText();
      if(blockText.trim() === '') //bug-tracker#264
        return '';
      let style = '';
      if( data.includes('ALIGN_CENTER'))
        style = "style='text-align:center;'"
      if(data.includes('ALIGN_RIGHT'))
        style = "style='text-align:right;'"
      if(data.includes('ALIGN_LEFT'))
        style = "style='text-align:left;'"
      return '<p '+style+'>' + blockText + '</p>'
    },
  },
  entityStyleFn: (entity) => {
    const entityType = entity.get('type').toLowerCase();
    console.log("entityType",entityType);

    if (entityType === 'image') {
      const data = entity.getData();
      //console.log('image-data',data);
      let computedWidth = data.width;
      if(computedWidth === undefined)
      computedWidth = 30;
      return {
        element: 'img',
        attributes: {
          src: data.src,
        },
        style: {
          width: computedWidth+'%'
        },
      };
    }
    if (entityType === 'draft-js-video-plugin-video') {
      const data = entity.getData();
      //console.log('image-data',data);
      let computedWidth = data.width;
      if(computedWidth === undefined)
      computedWidth = 30;
      return {
        element: 'iframe',
        attributes: {
          src: data.src,
          width: 420,
          height: 315
        }
      };
    }
  },
};

let StringExtract = function(stringInp,prefix, suffix) {
  if(stringInp === undefined || stringInp === null || stringInp.length < 1)
    return stringInp;
  let s = stringInp;
	var i = s.indexOf(prefix);
	if (i >= 0) {
		s = s.substring(i + prefix.length);
	}
	else {
		return '';
	}
	if (suffix) {
		i = s.indexOf(suffix);
		if (i >= 0) {
			s = s.substring(0, i);
		}
		else {
		  return '';
		}
	}
	return s;
};

let optionsHTML = {
  // Should return a Style() or Entity() or null/undefined
  customInlineFn: (element, {Style, Entity}) => {
    if (element.tagName === 'IMG') {
      //console.log('image-data',element);
      let styleString = element.getAttribute('style');
      let widthValue =  StringExtract(styleString,"width:","%");

      if(widthValue === null || widthValue === undefined || isNaN(widthValue))
      {
        widthValue  = '30';
      }

       let alignment = null;
      if (styleString.includes('margin-left: auto') && styleString.includes('margin-right: auto')) {
        alignment = 'center';
      } else if (styleString.includes('float: right')) {
        alignment = 'right';
      } else if (styleString.includes('float: left')) {
        alignment = 'left';
      }
      //console.log('widthValue',widthValue);

      return Entity('IMAGE', {src: element.getAttribute('src'),width:widthValue, alignment: alignment},'IMMUTABLE');
    }

  },customBlockFn: (element) => {
    if (element.tagName === 'P') {
      let styleString = element.getAttribute('style');
      let alignmentValue =  StringExtract(styleString,"text-align:",";");
      let dataVal;
      if(alignmentValue !== null || alignmentValue !== undefined ){
        switch(alignmentValue){
          case "center":
            dataVal ='ALIGN_CENTER';
            break;
          case "right":
            dataVal = 'ALIGN_RIGHT';
            break;
          case "left":
            dataVal ='ALIGN_LEFT';
            break;
          default:
            dataVal ='ALIGN_LEFT';
            break;

        }
      }


      return {type: 'unstyled',data:{dataVal}};
    }
  }

};



export default class TextEditor extends Component {

    constructor(props)
    {
      super(props);



        this.plugins = [videoPlugin ];

        this.getEditorStateLocal = this.getEditorStateLocal.bind(this);
        this.setEditorStateLocal = this.setEditorStateLocal.bind(this);
    }


    _uploadImageCallBack  = (file) =>{

      const imageObject = {
        file: file,
        localSrc: URL.createObjectURL(file),
      }

      return new Promise(
        (resolve, reject) => {
          resolve({ data: { link: imageObject.localSrc } });
        }
      );
    }

    onChange = (editorState) => {
        this.props.onChange(editorState);
    };

    focus = () => {
        this.editor.focus();
    };

    toString()
    {
      return draftToHtml(convertToRaw(this.props.value.getCurrentContent()));
    }

    static replaceVectorVars(html, vectorVariableMap) {
      if (vectorVariableMap === null || vectorVariableMap === undefined) return html
      return html.replace(
          /\\eval\{(\\vec\{[^}]+\})_(x|y|mag|magnitude|angle|ang)\}/g,
          (match, vecName, prop) => {
              const vec = vectorVariableMap.get(vecName);
              if (!vec) return match;
              if (!(prop in vec)) return match;

              return vec[prop];
          }
      );
  }

    static doRPCalculations(html) {
      if (!html) return html;

      return html.replace(/{{(.*?)}}/g, (match, expr) => {
        try {
          const result = math.eval(expr.trim());
          return result;
        } catch (err) {
          return match; // fallback: keep original if error
        }
      });
    }

    
        static getHTMLStringFromEditorState = function(editorState, vectorVariableMap, variablesMap){
            let text = stateToHTML(editorState.getCurrentContent(),options);
    
            if (vectorVariableMap) {
              text = this.replaceVectorVars(text, vectorVariableMap)
            }
            if (variablesMap) {
              text = this.replaceRPVariableVars(text, variablesMap)
              text =  this.doRPCalculations(text)
            }
            
            return text;
        }

    //Static Helpers

    /* static getHTMLStringFromEditorState = function(editorState){
        //console.log('editorState',JSON.stringify(convertToRaw(editorState.getCurrentContent())));
        return stateToHTML(editorState.getCurrentContent(),options);
    } */
    static getHTMLStringFromEditorState = function(editorState){
      let text = stateToHTML(editorState.getCurrentContent(),options);
      text = text.replaceAll("<figure>", "");
      text = text.replaceAll("</figure>", "");
      return text;
    }

    

    static createEmptyValue    =   function()
    {
        return EditorState.createEmpty();
    }

    getEditorStateLocal()
    {


      return this.props.value;
    }

    setEditorStateLocal(editorState)
    {
      this.onChange(editorState);
    }

    render() {

        return(
            <div>
            </div>
        );
    }
}
